module.exports = __webpack_public_path__ + "static/media/image-card-1.655e0a53.png";